import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
	getMyServiceInfo,
	getMyOrders,
	getMyInvoices,
	getMyAmounts,
	getMyAutoPayInfo,
	getAutoPayAvailableCC,
	getAccountDistributionMethod,
	getAccountTypeDistributionMethods
} from '../../actions/homeInfoActions'
import {getAccountInfoById} from "../../actions/accountInfoActions";
import CustomerServices from './CustomerServices';
import {createLoadingSelector, selectHomeInfo, getAccountAutoPayStatus, selectLinkedAccounts, selectLinkedAccountsError, selectLinkedAccountsLoading, selectIsActive} from '../../selectors'
import {getCurrentPaymentProviderSupportsPaymentMethodStorage} from "../../actions/paymentProviderActions";
import {getUserPermissions} from "../../actions/authActions";
import LinkedAccount from "../../containers/LinkedAccounts/LinkedAccount"
import { fetchLinkedAccounts, fetchLinkedUsers } from '../../actions/linkedAccountsInfoActions';
import {toggleIsActive} from '../../actions/linkedAccountsInfoActions'
import {getAccountAutoPay} from "../../actions/autoPayActions";
import Loader from "../../components/common/Spinners/Loader";
import {getNotificationCategories} from "../../actions/notifications";

class Home extends Component {

	static propTypes = {
		accountInfo: PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);
		this.state = {
			isActive: true,
			isLoading: false,
		};
	}

	componentDidMount() {
		const {
			accountInfo,
			getMyServiceInfo,
			getMyOrders,
			getMyInvoices,
			getMyAmounts,
			getMyAutoPayInfo,
			getAutoPayAvailableCC,
			getAccountDistributionMethod,
			getAccountTypeDistributionMethods,
			getAccountAutoPay,
			getUserPermissions,
			fetchLinkedAccounts,
			fetchLinkedUsers
		} = this.props;

		this.setState({ isLoading: true });

		Promise.all([
			fetchLinkedAccounts(accountInfo.primaryContact.user.id),
			fetchLinkedUsers(accountInfo.id),
			getMyServiceInfo(accountInfo.id),
			getMyOrders(accountInfo.id),
			getMyInvoices(accountInfo.id),
			getMyAmounts(accountInfo.id),
			getMyAutoPayInfo(accountInfo.id),
			getAutoPayAvailableCC(accountInfo.id),
			getAccountDistributionMethod(accountInfo.id),
			getAccountTypeDistributionMethods(accountInfo.accountType.name),
			getUserPermissions()
		]).then(() => {
			this.setState({ isLoading: false });
		}).catch((error) => {
			console.error("Error fetching account info:", error);
			this.setState({ isLoading: false });
		});
	}

	updateAccountInfo = async (accountId, accountTypeName) => {
		const {
			getMyServiceInfo,
			getMyOrders,
			getMyInvoices,
			getMyAmounts,
			getMyAutoPayInfo,
			getAutoPayAvailableCC,
			getAccountDistributionMethod,
			getAccountTypeDistributionMethods,
			getUserPermissions,
			toggleIsActive,
			getNotificationCategories
		} = this.props;

		try {
			await Promise.all([
				getMyServiceInfo(accountId),
				getMyOrders(accountId),
				getMyInvoices(accountId),
				getMyAmounts(accountId),
				getMyAutoPayInfo(accountId),
				getAutoPayAvailableCC(accountId),
				getAccountDistributionMethod(accountId),
				getAccountTypeDistributionMethods(accountTypeName),
				getUserPermissions(),
				getNotificationCategories(accountId)
			]).then(() => {
				this.setState({isLoading: false});
			}).catch((error) => {
				console.error(error)
				this.setState({isLoading: false});
			});

			toggleIsActive(false);
		} catch (error) {
			console.error("Error updating account info:", error);
		}
	};

	handleManageClick = async (accountId, accountTypeName) => {
		this.setState({isLoading: true})


		try {
			const linkedAccountSelected = await this.props.getAccountInfoById(accountId);
			this.updateAccountInfo(this.props.accountInfo.id, this.props.accountInfo.accountType.name);
		} catch (err) {

		}
	}
	render() {



		const {
			accountInfo,
			myServiceInfoLoader,
			myOrdersInfoLoader,
			myInvoicesInfoLoader,
		} = this.props;


		if (this.state.isLoading) {

			return <div className="cp-page cp-page-dashboard"> <Loader/></div>;
		}

		return (
			<div className="cp-page cp-page-dashboard">
				{/*<div className="container-alert-primary" />*/}

				{(this.props.linkedAccounts && this.props.linkedAccounts.linkedAccountList && this.props.linkedAccounts.linkedAccountList.length > 0 && this.props.isActive) ? (
					<LinkedAccount handleManageClick={this.handleManageClick} linkedAccounts={this.props.linkedAccounts} primaryAccountInfo={accountInfo}/>
				) : (
					<CustomerServices
						myServiceInfoLoader={myServiceInfoLoader}
						myOrdersInfoLoader={myOrdersInfoLoader}
						myInvoicesInfoLoader={myInvoicesInfoLoader}
						{...this.props}
					/>
				)}

				{/* <CustomerMenagment /> */}
			</div>
		);
	}
}
const getMyServiceInfoLoader = createLoadingSelector(['MY_SERVICE']);
const getMyOrdersInfoLoader = createLoadingSelector(['MY_ORDERS']);
const getMyInvoicesInfoLoader = createLoadingSelector(['MY_INVOICES']);
const getMyAmountsLoader = createLoadingSelector(['MY_AMOUNTS']);

const mapStateToProps = (state) => {

	const
		myServiceInfo = selectHomeInfo(state).myServiceInfo,
		myServiceInfoLoader = getMyServiceInfoLoader(state),
		myOrders = selectHomeInfo(state).myOrders,
		myOrdersInfoLoader = getMyOrdersInfoLoader(state),
		myInvoices = selectHomeInfo(state).myInvoices,
		myInvoicesInfoLoader = getMyInvoicesInfoLoader(state),
		myAmounts = selectHomeInfo(state).myAmounts,
		myAmountsLoader = getMyAmountsLoader(state),
		myAutoPayInfo = selectHomeInfo(state).myAutoPayInfo,
		myAutoPayAvailableCC = selectHomeInfo(state).myAutoPayAvailableCC,
		myDistributionMethods = selectHomeInfo(state).myDistributionMethods,
		myCurrentDistributionMethod = selectHomeInfo(state).myCurrentDistributionMethod,
		myAutoPayStatus = getAccountAutoPayStatus(state),
		myAutoPayWarning = getAccountAutoPayStatus(state).autoPayWarningMessage,
		linkedAccounts = selectLinkedAccounts(state),
		loading =selectLinkedAccountsLoading(state),
		error =selectLinkedAccountsError(state),
		isActive= selectIsActive(state);

		return {
		myServiceInfo,
		myServiceInfoLoader,
		myOrders,
		myOrdersInfoLoader,
		myInvoices,
		myInvoicesInfoLoader,
		myAmounts,
		myAmountsLoader,
		myAutoPayInfo,
		myAutoPayAvailableCC,
		myDistributionMethods,
		myCurrentDistributionMethod,
		linkedAccounts,
		loading,
		error,
		isActive
	}
};

const mapDispatchToProps = {
	getMyServiceInfo,
	getMyOrders,
	getMyInvoices,
	getMyAmounts,
	getMyAutoPayInfo,
	getAccountAutoPay,
	getAutoPayAvailableCC,
	getAccountDistributionMethod,
	getAccountTypeDistributionMethods,
	getCurrentPaymentProviderSupportsPaymentMethodStorage,
	getUserPermissions,
	fetchLinkedAccounts,
	getAccountInfoById,
	toggleIsActive,
	fetchLinkedUsers,
	getNotificationCategories

};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
